import moment from "moment";

export const parseDate = dateString => {
    if (!dateString) return null;
    try {
        let d = new Date(dateString);
        return isNaN(d.getTime()) ? null : d;
    } catch (e) {
        return null;
    }
};

export const dateToFilterFormat = (date) => {
    const innerFormat = "YYYY-MM-DDT00:00:00";
    return date ? moment(date).format(innerFormat) : null;
}


// WEBPACK FOOTER //
// ./App/services/date.js